/* R36: no prices on the homepage */
var NOPRICE = document.body && document.body.classList.contains('template-index');
/* Riviera Towel Co. — Concept A behaviors: hero slider, Colorful Search, add-set, gift note, recently viewed. */
(function () {
  'use strict';
  var money = function (cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- hero slider ---------- */
  document.querySelectorAll('[data-rt-slider]').forEach(function (el) {
    var slides = el.querySelectorAll('[data-slide]'), dots = el.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 7000, t;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() { if (reduce) return; clearInterval(t); t = setInterval(function () { go(i + 1); }, ms); }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-next')) go(i + 1); else if (b.hasAttribute('data-prev')) go(i - 1); else if (b.hasAttribute('data-dot')) go(+b.getAttribute('data-dot'));
      play();
    });
    el.addEventListener('mouseenter', function () { clearInterval(t); });
    el.addEventListener('mouseleave', play);
    play();
  });

  /* ---------- color families (same as RivieraGift) ---------- */
  var FAMS = [
    { id: 'pink', label: 'Pink', hex: '#f06ea9', keys: ['pink', 'fuchsia', 'fuschia', 'rose', 'peony', 'blush', 'magenta', 'flamingo', 'raspberry'] },
    { id: 'red', label: 'Red', hex: '#d62b2b', keys: ['red', 'burgundy', 'maroon', 'wine', 'cherry', 'crimson', 'brick', 'cranberry'] },
    { id: 'orange', label: 'Orange', hex: '#f28a3a', keys: ['orange', 'coral', 'mango', 'tangerine', 'peach', 'rust', 'terracotta', 'apricot', 'salmon'] },
    { id: 'yellow', label: 'Yellow', hex: '#f3cf3a', keys: ['yellow', 'yolk', 'mustard', 'gold', 'lemon', 'sunflower'] },
    { id: 'green', label: 'Green', hex: '#4aa564', keys: ['green', 'hunter', 'mint', 'sage', 'olive', 'lime', 'aloe', 'emerald', 'forest', 'moss', 'kelly'] },
    { id: 'teal', label: 'Teal', hex: '#27b3b0', keys: ['teal', 'turquoise', 'aqua', 'seafoam', 'turq'] },
    { id: 'blue', label: 'Blue', hex: '#3b7fd1', keys: ['blue', 'denim', 'royal', 'sky', 'aegean', 'indigo', 'cobalt', 'azure', 'ocean'] },
    { id: 'navy', label: 'Navy', hex: '#1d2f5c', keys: ['navy', 'marine'] },
    { id: 'purple', label: 'Purple', hex: '#8559c4', keys: ['purple', 'violet', 'lilac', 'lavender', 'plum', 'grape', 'mauve', 'orchid'] },
    { id: 'white', label: 'White', hex: '#f4f1ea', keys: ['white', 'cream', 'ivory', 'natural', 'ecru'] },
    { id: 'beige', label: 'Beige', hex: '#d6c2a0', keys: ['beige', 'sand', 'taupe', 'khaki', 'camel', 'oat', 'stone', 'mink', 'tan'] },
    { id: 'brown', label: 'Brown', hex: '#7a5a40', keys: ['brown', 'mocha', 'chocolate', 'espresso', 'coffee', 'chestnut', 'cocoa', 'walnut'] },
    { id: 'grey', label: 'Grey', hex: '#9aa3ad', keys: ['grey', 'gray', 'silver', 'charcoal', 'slate', 'graphite'] },
    { id: 'black', label: 'Black', hex: '#222222', keys: ['black', 'onyx'] }
  ];
  FAMS.forEach(function (f) { f.re = new RegExp('\\b(' + f.keys.join('|') + ')', 'i'); });
  var famById = {}; FAMS.forEach(function (f) { famById[f.id] = f; });
  function famsOf(name) { return FAMS.filter(function (f) { return f.re.test(name); }).map(function (f) { return f.id; }); }

  var cache = {};
  function loadCollection(handle) {
    if (cache[handle]) return cache[handle];
    var all = [];
    function page(n) {
      return fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { all = all.concat(d.products || []); return (d.products || []).length === 250 && n < 6 ? page(n + 1) : all; })
        .catch(function () { return all; });
    }
    cache[handle] = page(1);
    return cache[handle];
  }
  /* returns one entry per product+color: the first available variant whose title matches a selected family */
  function matchProducts(products, fams) {
    var out = [], seen = {};
    products.forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        var name = [v.title, v.option1, v.option2, v.option3].join(' ');
        var hit = famsOf(name).some(function (f) { return fams.indexOf(f) > -1; });
        if (!hit || !v.available) return; /* R46: an in-stock size of a color counts, even if another size is sold out */
        var colorKey = p.id + '|' + (v.option1 || v.title);
        if (seen[colorKey]) return;
        seen[colorKey] = 1;
        var img = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
        out.push({ p: p, v: v, img: img, avail: v.available });
      });
    });
    /* available first, then round-robin across products so one towel doesn't fill the grid */
    var groups = [], gi = {};
    out.forEach(function (m) { if (!(m.p.id in gi)) { gi[m.p.id] = groups.length; groups.push([]); } groups[gi[m.p.id]].push(m); });
    groups.forEach(function (g) { g.sort(function (a, b) { return (b.avail ? 1 : 0) - (a.avail ? 1 : 0); }); });
    var mixed = [], more = true, r = 0;
    while (more) { more = false; groups.forEach(function (g) { if (g[r]) { mixed.push(g[r]); more = true; } }); r++; }
    /* R37: only in-stock colors in search results, never a "Sold out" card */
    return mixed.filter(function (m) { return m.avail; });
  }
  function sized(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function cardHtml(m) {
    var title = m.p.title.split(' - RT')[0];
    var color = m.v.option1 && m.v.option1 !== 'Default Title' ? m.v.option1 : '';
    var price = Math.round(parseFloat(m.v.price) * 100);
    return '<a class="rt-card" href="' + root + 'products/' + m.p.handle + '?variant=' + m.v.id + '">' +
      '<span class="rt-arch" style="aspect-ratio:4/5">' + (m.img ? '<img src="' + esc(sized(m.img, 600)) + '" srcset="' + esc(sized(m.img, 360)) + ' 360w, ' + esc(sized(m.img, 600)) + ' 600w" sizes="(min-width:990px) 260px, 46vw" alt="' + esc(title + ' ' + color) + '" loading="lazy">' : '') +
      '</span>' +
      '<span class="rt-card__name">' + esc(title) + '</span>' +
      '<span class="rt-card__price">' + esc(color) + (NOPRICE ? '' : (color ? ' · ' : '') + money(price)) + '</span></a>';
  }

  document.querySelectorAll('[data-rt-cs]').forEach(function (cs) {
    var swWrap = cs.querySelector('[data-sws]'), go = cs.querySelector('[data-go]'), hint = cs.querySelector('[data-hint]'), res = cs.querySelector('[data-results]');
    var handles = (cs.getAttribute('data-handles') || '').split(',').filter(Boolean);
    var limit = parseInt(cs.getAttribute('data-limit'), 10) || 12;
    var sel = [], cat = '', shown = limit, last = [];
    FAMS.forEach(function (f) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rt-cs__sw'; b.setAttribute('data-fam', f.id); b.setAttribute('aria-pressed', 'false');
      b.innerHTML = '<i class="rt-hx" style="--c:' + f.hex + '"></i><span>' + f.label + '</span>';
      swWrap.appendChild(b);
    });
    function render() {
      [].forEach.call(swWrap.children, function (b) { b.setAttribute('aria-pressed', String(sel.indexOf(b.getAttribute('data-fam')) > -1)); });
      go.disabled = !sel.length;
      hint.textContent = sel.length ? 'Showing: ' + sel.map(function (id) { return famById[id].label; }).join(' + ') : 'Tap one or more colors';
    }
    function names() { return sel.map(function (id) { return famById[id].label; }).join(' + '); }
    function head() {
      var what = cat ? (cs.querySelector('[data-cat="' + cat + '"]') || {}).textContent : 'pieces';
      return '<div class="rt-cs__rhead"><h3 class="rt-cs__rtitle" tabindex="-1" data-rhead>' +
        (last.length ? 'Showing ' + last.length + ' ' + (what || 'pieces').toLowerCase() + ' in ' + names() : 'Nothing in ' + names() + ' right now') +
        '</h3><button type="button" class="rt-cs__up" data-up>Change colors &uarr;</button></div>';
    }
    function scrollToResults() {
      var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rt-hdr-h'), 10) || 120;
      var y = res.getBoundingClientRect().top + window.pageYOffset - hdr - 16;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      var h = res.querySelector('[data-rhead]'); if (h) setTimeout(function () { h.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    }
    function draw() {
      if (!last.length) {
        var tips = FAMS.filter(function (f) { return sel.indexOf(f.id) < 0; }).slice(0, 4);
        res.innerHTML = head() + '<div class="rt-cs__empty"><p>We do not have that shade in stock right now. Try one of these, or <a href="/collections/essential-collection">browse all towels</a>.</p><div class="rt-cs__tips">' +
          tips.map(function (f) { return '<button type="button" class="rt-cs__tip" data-tip="' + f.id + '"><i class="rt-hx" style="--c:' + f.hex + '"></i>' + f.label + '</button>'; }).join('') + '</div></div>';
        return;
      }
      res.innerHTML = head() + '<div class="rt-grid4">' + last.slice(0, shown).map(cardHtml).join('') + '</div>' +
        (last.length > shown ? '<div class="rt-cs__more"><button type="button" class="rt-btn rt-btn--light" data-more>Show more (' + (last.length - shown) + ')</button></div>' : '');
    }
    function run() {
      if (!sel.length) return;
      var list = cat ? [cat] : handles;
      if (!list.length) list = ['all'];
      res.hidden = false; res.innerHTML = '<p class="rt-cs__empty">Gathering colors…</p>'; scrollToResults();
      go.disabled = true;
      Promise.all(list.map(loadCollection)).then(function (arrs) {
        var byId = {}, products = [];
        arrs.forEach(function (a) { a.forEach(function (p) { if (!byId[p.id]) { byId[p.id] = 1; products.push(p); } }); });
        last = matchProducts(products, sel); shown = limit; draw();
        hint.textContent = last.length + ' match' + (last.length === 1 ? '' : 'es') + ' in ' + names();
        requestAnimationFrame(scrollToResults);
        go.disabled = false;
        try { history.replaceState(null, '', '#col=' + sel.join(',')); } catch (e) {}
      });
    }
    swWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.rt-cs__sw'); if (!b) return;
      var id = b.getAttribute('data-fam'), k = sel.indexOf(id);
      if (k > -1) sel.splice(k, 1); else sel.push(id);
      render();
    });
    cs.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cat]');
      if (c) { cat = c.getAttribute('data-cat'); cs.querySelectorAll('[data-cat]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); }); if (sel.length && !res.hidden) run(); }
      if (e.target.closest('[data-more]')) { shown += limit; draw(); }
      if (e.target.closest('[data-up]')) { var r = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; cs.scrollIntoView({ behavior: r ? 'auto' : 'smooth' }); var f = swWrap.querySelector('.rt-cs__sw'); if (f) f.focus({ preventScroll: true }); }
      var t = e.target.closest('[data-tip]'); if (t) { sel = [t.getAttribute('data-tip')]; render(); run(); }
    });
    go.addEventListener('click', run);
    // Enter on a swatch or category chip runs the search (Space still toggles)
    cs.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var sw = e.target.closest('.rt-cs__sw'), ch = e.target.closest('[data-cat]');
      if (!sw && !ch) return;
      e.preventDefault();
      if (sw) { var id = sw.getAttribute('data-fam'); if (sel.indexOf(id) < 0) { sel.push(id); render(); } }
      if (ch) ch.click();
      if (sel.length) run();
    });
    render();
    var m = (location.hash || '').match(/col=([a-z,]+)/);
    if (m) { sel = m[1].split(',').filter(function (id) { return famById[id]; }); render(); if (sel.length) { try { history.scrollRestoration = 'manual'; } catch (e) {} run(); var again = function () { setTimeout(scrollToResults, 400); }; if (document.readyState === 'complete') again(); else window.addEventListener('load', again); setTimeout(scrollToResults, 1800); } }
  });

  /* ---------- color ribbon on collection pages: filter in place ---------- */
  document.querySelectorAll('[data-rt-ribbon]').forEach(function (rb) {
    var handle = rb.getAttribute('data-collection'), out = document.querySelector(rb.getAttribute('data-target') || '[data-rt-ribbon-results]');
    var row = rb.querySelector('.rt-ribbon__row');
    FAMS.forEach(function (f) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rt-ribbon__sw'; b.setAttribute('data-fam', f.id); b.setAttribute('aria-pressed', 'false');
      b.innerHTML = '<i class="rt-hx" style="--c:' + f.hex + '"></i><span>' + f.label + '</span>';
      row.appendChild(b);
    });
    /* R46: only offer colors this collection has in stock; the rest sit greyed out on a second row */
    loadCollection(handle).then(function (ps) {
      var none = row.parentNode.querySelector('.rt-ribbon__row--none');
      FAMS.forEach(function (f) {
        var b = row.querySelector('[data-fam="' + f.id + '"]'); if (!b) return;
        var n = matchProducts(ps, [f.id]).length;
        if (n) { b.setAttribute('title', f.label + ' \u00b7 ' + n + ' in stock'); return; }
        if (!none) { none = document.createElement('div'); none.className = 'rt-ribbon__row rt-ribbon__row--none'; none.setAttribute('aria-label', 'Colors not in stock right now'); row.parentNode.insertBefore(none, row.nextSibling); }
        b.disabled = true; b.classList.add('rt-ribbon__sw--none'); b.setAttribute('title', f.label + ' \u00b7 not in stock right now'); b.setAttribute('aria-disabled', 'true');
        none.appendChild(b);
      });
      if (none) rb.classList.add('rt-ribbon--split');
    }).catch(function () {});
    var clearAll = function () {
      row.querySelectorAll('.rt-ribbon__sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      if (out) { out.hidden = true; out.innerHTML = ''; }
      rb.classList.remove('rt-ribbon--on');
      try { history.replaceState(null, '', location.pathname + location.search); } catch (x) {}
      var g = document.querySelector('.rt-chero') || rb; var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rt-hdr-h'), 10) || 120;
      window.scrollTo({ top: Math.max(0, g.getBoundingClientRect().bottom + window.pageYOffset - hdr - 12), behavior: 'smooth' });
    };
    var clr = document.createElement('button'); clr.type = 'button'; clr.className = 'rt-ribbon__clear'; clr.innerHTML = '&times; All colors'; clr.addEventListener('click', clearAll);
    row.parentNode.insertBefore(clr, row.nextSibling);
    if (out) out.addEventListener('click', function (e) { if (e.target.closest('[data-ribbon-clear]')) { clearAll(); return; } if (e.target.closest('[data-ribbon-up]')) { rb.scrollIntoView({ behavior: 'smooth', block: 'center' }); var f = row.querySelector('[aria-pressed="true"]') || row.querySelector('.rt-ribbon__sw'); if (f) f.focus({ preventScroll: true }); } });
    row.addEventListener('click', function (e) {
      var b = e.target.closest('.rt-ribbon__sw'); if (!b || !out || b.disabled) return;
      var on = b.getAttribute('aria-pressed') !== 'true';
      row.querySelectorAll('.rt-ribbon__sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      if (!on) { clearAll(); return; }
      b.setAttribute('aria-pressed', 'true'); rb.classList.add('rt-ribbon--on');
      out.hidden = false; out.innerHTML = '<p class="rt-cs__empty" style="color:var(--rt-navy)">Finding ' + famById[b.getAttribute('data-fam')].label.toLowerCase() + '…</p>';
      var goDown = function () {
        var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rt-hdr-h'), 10) || 120;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: out.getBoundingClientRect().top + window.pageYOffset - hdr - 12, behavior: reduce ? 'auto' : 'smooth' });
        var h = out.querySelector('[data-rhead]'); if (h) setTimeout(function () { h.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      };
      goDown();
      loadCollection(handle).then(function (ps) {
        var hits = matchProducts(ps, [b.getAttribute('data-fam')]);
        var lbl = esc(famById[b.getAttribute('data-fam')].label);
        var hd = '<div class="rt-cs__rhead"><h2 class="rt-cs__rtitle" tabindex="-1" data-rhead>' + (hits.length ? 'Showing ' + hits.length + ' in ' + lbl : 'No ' + lbl.toLowerCase() + ' here right now') + '</h2><span class="rt-cs__rbtns"><button type="button" class="rt-cs__up" data-ribbon-up>Change color &uarr;</button><button type="button" class="rt-cs__up rt-cs__up--clear" data-ribbon-clear>&times; Show all</button></span></div>';
        out.innerHTML = '<div class="rt-wrap" style="padding-top:34px;padding-bottom:30px">' + hd + (hits.length ? '<div class="rt-grid4">' + hits.slice(0, 48).map(cardHtml).join('') + '</div>' : '<p class="rt-cs__empty" style="color:var(--rt-navy)">Try another color, or scroll down to see the whole collection.</p>') + '</div>';
        requestAnimationFrame(goDown);
      });
    });
  });

  /* ---------- add several variants to cart (Build a Set, Complete the set) ---------- */
  function addToCart(items, btn, msgEl, okText) {
    if (btn) btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (added) {
        if (msgEl) msgEl.innerHTML = (okText || 'Added to your bag \u2713') + ' <a class="rt-set__bag" href="' + root + 'cart">View your bag &amp; check out \u2192</a>';
        /* refresh the cart drawer with the new items and slide it open, so shoppers see their set right away */
        if (drawer && added && added.sections && added.sections['cart-drawer']) {
          try {
            var fresh = new DOMParser().parseFromString(added.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
            var cur = document.querySelector('#CartDrawer');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
            var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
            var ov = drawer.querySelector('#CartDrawer-Overlay'); if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
            if (drawer.open) setTimeout(function () { drawer.open(); }, 50);
          } catch (e) {}
        }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var n = bubble.querySelector('.cart-count-bubble');
            if (!n) { n = document.createElement('div'); n.className = 'cart-count-bubble'; bubble.appendChild(n); }
            n.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>';
          }
          document.dispatchEvent(new CustomEvent('rt:cart', { detail: c }));
        });
      })
      .catch(function (err) { if (msgEl) msgEl.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added.'; })
      .then(function () { if (btn) btn.disabled = false; });
  }
  /* Build-a-Set: pick a color for each towel (in-stock only); the photo and the "Add the set" ids follow the picks */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('.rt-set__more');
    if (more) { more.parentNode.classList.add('is-open'); more.remove(); return; }
    var sw = e.target.closest('.rt-set__sw'); if (!sw) return;
    var pick = sw.closest('[data-pick]'), card = sw.closest('[data-rt-set]'), side = sw.closest('[data-side]');
    pick.querySelectorAll('.rt-set__sw').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
    sw.classList.add('is-on'); sw.setAttribute('aria-pressed', 'true');
    var nm = pick.querySelector('[data-cname]'); if (nm) nm.textContent = sw.getAttribute('data-name');
    var arch = card.querySelector('[data-arch="' + side.getAttribute('data-side') + '"] img');
    if (arch && sw.getAttribute('data-img')) { arch.removeAttribute('srcset'); arch.src = sw.getAttribute('data-img'); }
    var btn = card.querySelector('[data-add]'), ids = btn.getAttribute('data-add').split(',');
    ids[side.getAttribute('data-side') === 'a' ? 0 : 1] = sw.getAttribute('data-vid');
    btn.setAttribute('data-add', ids.join(','));
    var msg = card.querySelector('[data-msg]'); if (msg && msg.getAttribute('data-orig') == null) msg.setAttribute('data-orig', msg.textContent);
    if (msg) msg.textContent = msg.getAttribute('data-orig');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b) return;
    var ids = b.getAttribute('data-add').split(',').filter(Boolean);
    var card = b.closest('[data-rt-set], .rt-complete__item');
    addToCart(ids.map(function (id) { return { id: +id, quantity: 1 }; }), b, card && card.querySelector('[data-msg]'));
  });

  /* ---------- gift wrap + handwritten note on product page ---------- */
  document.querySelectorAll('[data-rt-giftcard]').forEach(function (g) {
    var cb = g.querySelector('input[type=checkbox]'), ta = g.querySelector('textarea');
    var form = document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') || document.querySelector('product-form form');
    cb.addEventListener('change', function () { g.classList.toggle('is-on', cb.checked); if (cb.checked) ta.focus(); });
    if (!form) return;
    form.addEventListener('submit', function () {
      if (!cb.checked) return;
      var wrapId = g.getAttribute('data-variant');
      var note = ta.value.trim();
      var items = [];
      if (wrapId) items.push({ id: +wrapId, quantity: 1, properties: note ? { 'Handwritten note': note } : {} });
      if (items.length) setTimeout(function () { addToCart(items, null, null); }, 900);
      if (note && !wrapId) fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: 'Handwritten note: ' + note }) });
    }, true);
  });

  /* ---------- free shipping progress ---------- */
  function shipBars(cart) {
    document.querySelectorAll('[data-rt-ship]').forEach(function (s) {
      var goal = parseInt(s.getAttribute('data-goal'), 10) || 7500, have = cart ? cart.total_price : parseInt(s.getAttribute('data-have'), 10) || 0;
      var left = Math.max(0, goal - have), pct = Math.min(100, Math.round(have / goal * 100));
      var t = s.querySelector('[data-text]'), bar = s.querySelector('i');
      if (t) t.innerHTML = left ? 'You\'re <b>' + money(left) + '</b> away from free shipping' : '<b>You\'ve unlocked free shipping!</b>';
      if (bar) bar.style.width = pct + '%';
    });
  }
  shipBars(null);
  document.addEventListener('rt:cart', function (e) { shipBars(e.detail); });
  ['cart:updated', 'cart-update'].forEach(function (ev) { document.addEventListener(ev, function () { fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(shipBars); }); });

  /* ---------- recently viewed ---------- */
  var KEY = 'rt_recent';
  var cur = document.querySelector('[data-rt-product-handle]');
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
  if (cur) {
    var h = cur.getAttribute('data-rt-product-handle');
    list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  document.querySelectorAll('[data-rt-recent]').forEach(function (box) {
    var skip = cur ? cur.getAttribute('data-rt-product-handle') : '';
    var hs = list.filter(function (x) { return x !== skip; }).slice(0, 4);
    if (!hs.length) return;
    Promise.all(hs.map(function (hh) { return fetch(root + 'products/' + hh + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) return;
        box.querySelector('[data-grid]').innerHTML = ps.map(function (p) {
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          return '<a class="rt-card" href="' + p.url + '"><span class="rt-arch" style="aspect-ratio:4/5">' + (img ? '<img src="' + esc(sized(img, 600)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span><span class="rt-card__name">' + esc(p.title.split(' - RT')[0]) + '</span>' + (NOPRICE ? '' : '<span class="rt-card__price">' + (p.price_varies ? 'from ' : '') + money(p.price) + '</span>') + '</a>';
        }).join('');
        box.hidden = false;
      });
  });
  /* ---------- color dots on product color pills ---------- */
  function dotify(scope) {
    (scope || document).querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend'); if (!lg || !/colou?r/i.test(lg.textContent)) return;
      fs.querySelectorAll('input[type=radio] + label').forEach(function (lb) {
        if (lb.querySelector('.rt-dot')) return;
        var name = (lb.textContent || '').trim(), hexes = FAMS.filter(function (f) { return f.re.test(name); }).map(function (f) { return f.hex; });
        if (!hexes.length) return;
        var d = document.createElement('i'); d.className = 'rt-dot';
        d.style.background = hexes.length > 1 ? 'linear-gradient(135deg,' + hexes[0] + ' 50%,' + hexes[1] + ' 50%)' : hexes[0];
        lb.insertBefore(d, lb.firstChild);
      });
    });
  }
  dotify();
  var vp = document.querySelector('variant-selects');
  if (vp && window.MutationObserver) new MutationObserver(function () { dotify(); }).observe(vp.parentNode, { childList: true, subtree: true });

  /* ---------- mega menus: open under their own item, forgiving hover, clamp to viewport ---------- */
  document.querySelectorAll('.rt-nav__item.has-mega').forEach(function (li) {
    var panel = li.querySelector('[data-rt-mega]'), t;
    if (!panel) return;
    function place() {
      panel.classList.remove('is-right');
      var r = panel.getBoundingClientRect();
      if (r.right > window.innerWidth - 16) panel.classList.add('is-right');
    }
    function open() { clearTimeout(t); var ae = document.activeElement; if (ae && ae.closest && ae.closest('.rt-nav__item') && !li.contains(ae)) ae.blur(); document.querySelectorAll('.rt-nav__item.is-open').forEach(function (o) { if (o !== li) o.classList.remove('is-open'); }); li.classList.add('is-open'); place(); }
    function close() { clearTimeout(t); t = setTimeout(function () { li.classList.remove('is-open'); }, 260); }
    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', close);
    li.addEventListener('focusin', open);
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
    li.addEventListener('keydown', function (e) { if (e.key === 'Escape') { li.classList.remove('is-open'); li.querySelector('.rt-nav__link').focus(); } });
  });
})();

/* Bundler ("You got $X OFF your order") pop-up: show it once, then hide it for 7 days. The bundle discount itself is untouched. */
(function () {
  var K = 'rt_bndlr_seen', DAY = 864e5, seen = 0;
  try { seen = +localStorage.getItem(K) || 0; } catch (e) {}
  if (Date.now() - seen < 7 * DAY) document.documentElement.classList.add('rt-bndlr-seen');
  function mark() { try { localStorage.setItem(K, String(Date.now())); } catch (e) {} }
  var mo = new MutationObserver(function () {
    var m = document.getElementById('bndlr-discount-message');
    if (!m) return;
    if (document.documentElement.classList.contains('rt-bndlr-seen')) { m.style.display = 'none'; return; }
    if (getComputedStyle(m).display !== 'none') { mark(); m.addEventListener('click', function () { document.documentElement.classList.add('rt-bndlr-seen'); }, { once: true }); }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Collection header: 2-line description with Read more; chips keep the chosen color; #col= on load picks it and scrolls */
(function () {
  // Collection intro: two lines max, with "Read more" inline at the end of the second line
  var d = document.querySelector('[data-rt-desc]');
  if (d) {
    var full = d.textContent.replace(/\s+/g, ' ').trim(), open = false;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'rt-chero__more';
    var fit = function () {
      d.classList.add('is-open'); d.textContent = full;
      var lh = parseFloat(getComputedStyle(d).lineHeight) || 24, max = lh * 2 + 2;
      if (open || d.scrollHeight <= max) { if (open) { d.appendChild(document.createTextNode(' ')); btn.textContent = 'Show less'; d.appendChild(btn); } return; }
      btn.textContent = 'Read more';
      var lo = 0, hi = full.length, cut = 0;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        d.textContent = full.slice(0, mid).replace(/[\s,.;:]+\S*$/, '') + '\u2026 '; d.appendChild(btn);
        if (d.scrollHeight <= max) { cut = mid; lo = mid + 1; } else hi = mid - 1;
      }
      d.textContent = full.slice(0, cut).replace(/[\s,.;:]+\S*$/, '') + '\u2026 '; d.appendChild(btn);
    };
    btn.addEventListener('click', function () { open = !open; fit(); });
    fit();
    var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(fit, 150); });
  }
  var rb = document.querySelector('.rt-chero__colors[data-rt-ribbon]'); if (!rb) return;
  var pills = document.querySelector('[data-rt-pills]');
  if (pills) pills.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (a) a.href = a.href.split('#')[0]; /* switching collections always shows everything, no color filter */
  });
  var mm = (location.hash || '').match(/col=([a-z]+)/);
  if (mm) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    var tries = 0, t = setInterval(function () {
      var b = rb.querySelector('.rt-ribbon__sw[data-fam="' + mm[1] + '"]');
      if (b || ++tries > 40) { clearInterval(t); if (b) b.click(); }
    }, 100);
  }
  rb.addEventListener('click', function (e) {
    var b = e.target.closest('.rt-ribbon__sw'); if (!b) return;
    setTimeout(function () { try { history.replaceState(null, '', b.getAttribute('aria-pressed') === 'true' ? '#col=' + b.getAttribute('data-fam') : location.pathname + location.search); } catch (x) {} }, 0);
  });
})();

/* Product page color picker: photo swatches, selected name in the label, sold-out colors tucked behind a toggle */
(function () {
  var fsAll = document.querySelectorAll('variant-selects fieldset.product-form__input'); if (!fsAll.length) return;
  var handle = (document.querySelector('[data-rt-product-handle]') || {}).getAttribute ? document.querySelector('[data-rt-product-handle]').getAttribute('data-rt-product-handle') : null;
  if (!handle) return;
  fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
    var ci = p.options.findIndex(function (o) { return /colou?r/i.test(o.name || o); }); if (ci < 0) return;
    var key = 'option' + (ci + 1), img = {}, avail = {};
    var qty = {}, RTQ = {}; try { var qe = document.querySelector('[data-rt-qty]'); if (qe) RTQ = JSON.parse(qe.textContent) || {}; } catch (e) {}
    p.variants.forEach(function (v) { var val = v[key]; if (v.featured_image && !img[val]) img[val] = v.featured_image.src; avail[val] = avail[val] || v.available; if (v.inventory_quantity > 0) qty[val] = (qty[val] || 0) + v.inventory_quantity; });
    function build() {
      document.querySelectorAll('variant-selects fieldset.product-form__input').forEach(function (fs) {
        var lg = fs.querySelector('legend'); if (!lg || !/colou?r/i.test(lg.textContent)) return;
        if (fs.classList.contains('rt-swatched') && fs.querySelector('.rt-sw')) return;
        fs.classList.add('rt-swatched');
        var labels = [].slice.call(fs.querySelectorAll('input[type=radio] + label')), sold = 0, total = labels.length;
        labels.forEach(function (lb) {
          /* R39: name from the option value (the label text also holds Dawn's hidden "Variant sold out or unavailable") */
          var inp = lb.previousElementSibling, val = inp.value, name = val;
          var note = avail[val] === false ? 'sold out' : (RTQ[val] > 0 ? RTQ[val] + ' in stock in Santa Barbara' : 'in stock in Santa Barbara');
          lb.setAttribute('title', name + ' \u00b7 ' + note);
          lb.setAttribute('aria-label', name + ', ' + note);
          lb.classList.add('rt-sw');
          if (img[val]) { var u = img[val].replace(/(\.(jpe?g|png|webp))(\?|$)/i, '_120x$1$3'); lb.style.setProperty('--sw', 'url("' + u + '")'); lb.classList.add('rt-sw--img'); }
          if (avail[val] === false) { lb.classList.add('rt-sw--sold'); inp.parentNode && (sold++); }
        });
        var cur = fs.querySelector('input[type=radio]:checked');
        var name = cur ? cur.value : '';
        if (!lg.querySelector('.rt-sw-name')) lg.insertAdjacentHTML('beforeend', ' <span class="rt-sw-name"></span><span class="rt-sw-count"></span>');
        lg.querySelector('.rt-sw-name').textContent = name;
        rtStockLabel(); /* R40: show the highlighted color's Santa Barbara count, not how many colors are in stock */
        if (sold && window.matchMedia('(max-width: 749px)').matches && !fs.querySelector('.rt-sw-more')) { /* R74: on phones, sold-out colors tuck behind a toggle so Add to cart sits higher; desktop keeps them struck through */
          fs.classList.add('rt-hide-sold');
          var b = document.createElement('button'); b.type = 'button'; b.className = 'rt-sw-more'; b.textContent = '+ ' + sold + ' sold-out colors';
          b.addEventListener('click', function () { var h = fs.classList.toggle('rt-hide-sold'); b.textContent = h ? '+ ' + sold + ' sold-out colors' : 'Hide sold-out colors'; });
          fs.appendChild(b);
        }
      });
    }
    function rtStockLabel() {
      var c = document.querySelector('.rt-swatched .rt-sw-count'); if (!c) return;
      var inv = document.querySelector('.product__inventory, [id^="Inventory-"]');
      var t = inv ? inv.textContent.replace(/\s+/g, ' ').trim() : '', m;
      var cur = document.querySelector('.rt-swatched input[type=radio]:checked');
      if (cur && cur.nextElementSibling && cur.nextElementSibling.classList.contains('rt-sw--sold')) c.textContent = ' \u00b7 sold out';
      else if ((m = t.match(/(\d+)\s+in stock/i))) c.textContent = ' \u00b7 ' + m[1] + ' in stock in Santa Barbara';
      else if ((m = t.match(/(\d+)\s+left/i))) c.textContent = ' \u00b7 only ' + m[1] + ' left in Santa Barbara';
      else c.textContent = '';
    }
    var invEl = document.querySelector('.product__inventory, [id^="Inventory-"]');
    if (invEl && window.MutationObserver) new MutationObserver(function () { setTimeout(rtStockLabel, 20); }).observe(invEl, { childList: true, subtree: true, characterData: true });
    build();
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(build, 60); });
    var vs = document.querySelector('variant-selects');
    if (vs && window.MutationObserver) new MutationObserver(function () { setTimeout(build, 30); }).observe(vs.parentNode, { childList: true, subtree: true });
  }).catch(function () {});
})();

/* R50: Show more on collection grids */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-rt-more-grid]'); if (!b) return;
  var hidden = document.querySelectorAll('.grid__item.rt-more-hidden'), n = 0;
  for (var i = 0; i < hidden.length && n < 36; i++) { hidden[i].classList.remove('rt-more-hidden'); n++; }
  var left = document.querySelectorAll('.grid__item.rt-more-hidden').length;
  if (left) b.textContent = 'Show more (' + left + ')'; else b.parentNode.removeChild(b);
});
